<template>
  <div class="searchCard"
       :class="{
         'searchCard--open': cardOpen,
         'type--nascimento': dataInfo.tipo_livro === 'N',
         'type--casamento': dataInfo.tipo_livro === 'C' || dataInfo.tipo_livro === 'D',
         'type--obito': dataInfo.tipo_livro === 'O' }">
    <div class="searchCard_header d-flex justify-content-between">
      <div class="d-inline-flex align-items-center">
        <!--        <b-form-checkbox class="mr-2"
                         :checked="check"
                         @change="selectCard(info)" />-->

        <IconSvg v-if="iconName"
                 :icon="iconName"
                 class="icon--xs mb-2 mt-1 mr-2" />

        <div v-if="(!display.registro_id) && (display.dataCriacao)"
             class="tagRascunho">
          <label>Rascunho</label>
        </div>

        <HeaderBoxInfo v-if="display.registro_id"
                       :info="display.num_livro"
                       text="Livro" />
        <HeaderBoxInfo v-if="display.registro_id"
                       :info="display.num_folha"
                       text="Folha" />
        <HeaderBoxInfo v-if="display.registro_id"
                       :info="dataInfo.termo"
                       text="Registro" />
        <HeaderBoxInfo v-if="display.registro_id"
                       :info="display.data_ocorrido | date"
                       text="Ocorrido" />
        <HeaderBoxInfo v-if="display.registro_id"
                       :info="display.data_registro | date"
                       text="Registrado" />
        <HeaderBoxInfo v-if="(!display.registro_id) && (display.dataCriacao)"
                       :info="display.dataCriacao | date"
                       text="Data de Criação" />
        <div v-if="dataInfo.cod_motivo_alt == 30"
             class="text-right searchCard--bloqueado">
          <b-badge v-b-tooltip.hover.right="'Registro bloqueado por Determinação Judicial'"
                   variant="danger">
            <b>Registro bloqueado</b>
          </b-badge>
        </div>
        <div v-if="(dataInfo.habilitacaoCasamento && dataInfo.habilitacaoCasamento.declaracao_pobreza) || (dataInfo.casamento && dataInfo.casamento.declaracao_pobreza)"
             class="text-right searchCard--bloqueado">
          <b-badge v-b-tooltip.hover.right="'Registro bloqueado por Determinação Judicial'"
                   variant="secondary">
            <b>Registro isento</b>
          </b-badge>
        </div>
      </div>
      <div v-if="!!dataInfo.transporte"
           class="text-right mr-2">
        <div v-b-tooltip.hover.right="'Registro Transportado'"
             class="transporteCircle">
          T
        </div>
      </div>
      <div v-if="rascunho"
           class="text-right searchCard--bloqueado mt-1">
        <button v-b-tooltip.hover.right="'Excluir rascunho'"
                v-ripple
                class="btn btn-sm btn-danger"
                @click="excluirRascunho(dataInfo)">
          <IconSvg class="icon--xs icons--white"
                   icon="trash" />
        </button>
      </div>
    </div>

    <SearchCardDetails :info="dataInfo"
                       :open-card="cardOpen"
                       :prop-segunda-via="propSegundaVia" />


    <CardAverbacao v-if="cardOpen"
                   :prop-transporte="dataInfo.transporte"
                   :id-registro="dataInfo" />

    <ImageBox
      v-if="cardOpen"
      class="mt-2"
      :image-list="display.arquivos"
      :registro-id="display.registro_id"
      :type-profile="tipoPerfil"
      @removed="imageRemoved" />

    <button class="searchCard_openDetails position-absolute w-100 text-center"
            @click="openCard">
      <svg class="searchCard_openDetails_icon icon--xxs"
           role="presentation">
        <use :xlink:href="'#' + arrowDown.id" />
      </svg>
    </button>
  </div>
</template>

<script>
  import SearchCardDetails from "./SearchCardDetails"
  import HeaderBoxInfo from "./HeaderBoxInfo"
  import CardAverbacao from "./CardAverbacao"
  import ImageBox from "./ImageBox"
  import arrowDown from "@/assets/icons/arrow-down.svg?sprite"
  import IconSvg  from "@/components/IconSvg"
  import RegistrosService from "@/services/Registros"

  export default {
    name: "SearchCard",
    components: {
      SearchCardDetails,
      CardAverbacao,
      HeaderBoxInfo,
      ImageBox,
      IconSvg,
    },
    props: {
      dataInfo: { type: Object, default: () => ({}) },
      check: { type: Boolean, default: false },
      rascunho: { type: Boolean, default: false },
      propSegundaVia: {type: Boolean, default: false }
    },
    data () {
      return {
        arrowDown,
        cardOpen: false,
        tipoPerfil: "",
        info: this.dataInfo,
        icons: {
          N: "nascimento",
          C: "engagement",
          CR: "engagement",
          D: "engagement",
          O: "flower",
          NT: "flower",
        }
      }
    },
    computed: {
      display () {
        return this.displayData(this.dataInfo)
      },
      iconName () {
        return this.icons[this.dataInfo.tipo_registro]
      }
    },
    mounted () {
      if (this.dataInfo.casamento) {
        this.tipoPerfil = 'C'
      } else if (this.dataInfo.habilitacaoCasamento) {
        this.tipoPerfil = 'D'
      } else if (this.dataInfo.nascimento) {
        this.tipoPerfil = 'N'
      } else {
        this.tipoPerfil = 'O'
      }
    },
    methods: {
      imageRemoved (index) {
        this.dataInfo.documentos.splice(index, 1)
      },
      openCard () {
        this.cardOpen = !this.cardOpen
      },
      selectCard (value) {
        this.$emit("onSelectCard", value)
      },
      displayData (data = {}) {
        const display = {
          nome_registrado: data.nome_registrado || "",
          num_livro: data.livro ? data.livro.num_livro : "000",
          num_folha: data.folha || "000",
          num_registro: data.registro_id || "000",
          data_ocorrido: data.data_ocorrido || "",
          data_registro: data.data_registro || "",
          averbacoes: data.averbacoes || [],
          arquivos: data.documentos || [],
          registro_id: data.registro_id || 0,
          dataCriacao: data.dataCriacao
        }

        return display
      },
      async excluirRascunho (rascunho) {
        const tiposCasamento = ['C', 'CR', 'D']
        let nome = null

        const { pessoas } = rascunho
        if (pessoas && pessoas.length == 2) {
          nome = (pessoas[0].nome_antigo || pessoas[0].nome || 'NÃO INFORMADO') + ' e ' + (pessoas[1].nome_antigo || pessoas[1].nome || 'NÃO INFORMADO')
        }
        else if (tiposCasamento.indexOf(this.dataInfo.tipo_registro) != -1) {
          // Criamos esta condicao para tratar Casamentos e Habilitacoes com apenas uma pessoa cadastrada no registro
          const primeiroConjuge = !!pessoas && pessoas[0] ? pessoas[0].nome_antigo : 'NÃO INFORMADO'
          const segundoConjuge = !!pessoas && pessoas[1] ? pessoas[1].nome_antigo : 'NÃO INFORMADO'
          nome = primeiroConjuge + ' e ' + segundoConjuge
        }
        else {
          nome = rascunho.registro.pessoa.nome
        }

        const resposta = await displayMessage('question', 'Atenção!', 'Deseja realmente excluir o rascunho de ' + nome + '?')

        if (resposta.value) {
          try {
            loader({ active: true, text: 'Excluindo rascunhos...' })
            await RegistrosService.deleteRascunho (rascunho.rascunho_id)
            this.$emit('onExcludeAll')
            // displayMessage('success', 'Rascunho excluido!')
            this.$toast.success(`Rascunho ${ rascunho.rascunho_id } excluido!`, {
              position: 'top-right',
              duration: 5000
            })
          } catch (e) {
            displayMessage('error', 'Erro ao excluir rascunhos', e)
          } finally {
            loader({ active: false, text: '' })
          }
        }
      }
    }
  }
</script>

<style lang="scss">
@import "../../../scss/_utilities/exports";

.searchCard {
  background-color: $color-white;
  box-shadow: 0 0 pxToRem(4) $color-gray;
  min-height: pxToRem(68);
  transition: all 0.15s linear;
  padding-bottom: pxToRem(24);
  position: relative;

  .btn.disabled, .btn:disabled {
    opacity: 0.35;
  }

  &--bloqueado {
    width: 345px;
  }

  .tagRascunho {
    background-color: $color-dark;
    font-weight: 500;
    text-align: center;
    width: pxToRem(110);
    padding-top: pxToRem(8);
    margin-right: pxToRem(7);
    padding-left: pxToRem(4);
    border-top-left-radius: pxToRem(20) 50%;
    border-bottom-left-radius: pxToRem(20) 50%;
  }

  &_header {
    background-color: $color-light-blue;
    color: $color-white;
    padding: pxToRem(4) pxToRem(8);
  }

  &_openDetails {
    background-color: rgba($color-dark, 0.2);
    border: none;
    cursor: pointer;
    bottom: 0;
    left: 0;
    max-height: pxToRem(20);
    right: 0;
    transition: background-color 0.15s linear;

    &_icon {
      outline: none;
      vertical-align: baseline;
    }

    &:hover,
    &:focus {
      background-color: rgba($color-dark, 0.4);
      outline: none;

      .searchCard_openDetails_icon {
        fill: $color-white;
        transition: transform 0.15s linear;
      }
    }
  }

  &--open {
    .searchCard_openDetails_icon {
      @include transform(rotate(-180deg));
    }
  }

  &.type--obito {
  }

  &.type--casamento {
  }

  &.type--nascimento {
  }

  @media (min-width: pxToRem(568)) {
  }

  @media (min-width: pxToRem(768)) {
  }
}

.miniBoxInfo {
  color: white;
  display: inline-block;
  font-size: pxToRem(14);
  padding: 0 0 0 pxToRem(24);
  position: relative;

  &:before {
    background: no-repeat center center;
    background-size: cover;
    bottom: 0;
    content: "";
    display: inline-block;
    height: pxToRem(16);
    left: pxToRem(4);
    margin-top: pxToRem(2);
    position: absolute;
    top: 0;
    width: pxToRem(16);
  }

  &--averb,
  &--image {
    @extend .miniBoxInfo;
  }

  &--averb {
    &:before {
      background-image: url("../../../assets/icons/note.svg");
    }

    &.hasentAverb {
      color: $color-aqua;

      &:before {
        background-image: url("../../../assets/icons/note-inactive.svg");
      }
    }
  }

  &--image {
    &:before {
      background-image: url("../../../assets/icons/file-image.svg");
    }

    &.hasentFiles {
      color: $color-aqua;

      &:before {
        background-image: url("../../../assets/icons/file-image-inactive.svg");
      }
    }
  }
}
.transporteCircle {
    width: 22px;
    line-height: 22px;
    border-radius: 50%;
    text-align: center;
    font-weight: 800;
    background-color: #004e86;
    border: 2px solid #004e86;
}
</style>
